var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.219 34.121c1.363.438 2.312 1.74 2.312 3.233v6.608c0 1.75-1.306 3.237-3.052 3.38-.524.042-1.049.08-1.573.111v4.766l-4.625-4.625c-2.087 0-4.153-.085-6.197-.252a3.261 3.261 0 0 1-1.272-.373m14.407-12.848a3.279 3.279 0 0 0-.734-.146 74.974 74.974 0 0 0-12.407 0c-1.744.145-3.047 1.63-3.047 3.379v6.608c0 1.29.71 2.435 1.78 3.007M52.22 34.121v-2.889c0-2.499-1.776-4.665-4.255-4.987a74.69 74.69 0 0 0-9.62-.62c-3.26 0-6.472.211-9.62.62-2.48.322-4.255 2.488-4.255 4.987v9.599c0 2.498 1.776 4.664 4.255 4.987.89.115 1.784.216 2.682.299v7.258l6.406-6.406",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6fc876184724a43042e859f26b2255d2.svg";
export { ForwardRef as ReactComponent };